import type { Options } from "ky";

import { getJson } from "#app/lib/fetchClient";

import { GATEWAY_PATHS, urlSearchParamsToString } from "../api-utils";

type GetPasswordForgotParams = {
  loginId: string;
};

export async function getPasswordForgot(
  params: GetPasswordForgotParams & Pick<Options, "signal">,
): Promise<void> {
  // Parse incoming
  const searchParams = parseParams(params);

  await getJson(
    `${GATEWAY_PATHS.bolAuthenticationService}/Password/Forgot${searchParams}`,
    { signal: params.signal },
    true,
  );
}

function parseParams(params: GetPasswordForgotParams) {
  // Destructure params
  const { loginId } = params;

  // Build urlSearchParams
  const urlSearchParams = new URLSearchParams({ loginId });

  // Create searchParams string
  const searchParams = urlSearchParamsToString(urlSearchParams);

  return searchParams;
}
